import { get } from 'svelte/store';
import type { ApiTypes } from '../enums/api.enum';
import type { IApiError } from '../interfaces/api-error.interface';
import { state_apiErrors, state_busyApi } from '../store/state';
import { defaultLogger, defaultLogger as logger } from '../telemetry/logger';

export function addApiError(err: IApiError): void {
  defaultLogger.debug(
    `API Error: ${err.apiType} - Status: ${err.status}, StatusText: ${err.statusText}, Error: ${err.error}, ErrorType: ${err.errorType}`
  );

  state_apiErrors.set([...get(state_apiErrors), err]);
  logger.error(`${err.apiType} API failure`, JSON.stringify(err));
}

export function removeApiError(type: ApiTypes): void {
  state_apiErrors.set([
    ...get(state_apiErrors).filter((x) => x.apiType !== type),
  ]);
}

export function addBusyApi(type: ApiTypes): void {
  state_busyApi.set([...get(state_busyApi), type]);
}

export function removeBusyApi(type: ApiTypes): void {
  state_busyApi.set([...get(state_busyApi).filter((x) => x !== type)]);
}
